import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import {
  TFinanceAction,
  selectedInvestmentStateFinance,
  selectedTransactionStateFinance,
  showModalStateFinance,
} from '../state/FinanceUIStateJ';
import { ITransactionDataModel } from '../../../data-models/transaction.data-model';
import { IFinanceRoundDataModel } from '../../../data-models/finance-round.data-model';
import { useTransactionHistoryAction } from './useTransactionHistoryAction';

export function useTransactionModalActions() {
  const { navigateToTransactionHistory } = useTransactionHistoryAction();
  const setShowModal = useSetAtom(showModalStateFinance);
  const setSelectedTransaction = useSetAtom(selectedTransactionStateFinance);

  const handleCloseModal = useCallback(() => {
    setShowModal(null);
    setSelectedTransaction(null);
  }, [setSelectedTransaction, setShowModal]);

  const handleClickAction = useCallback(
    (data: ITransactionDataModel, action: TFinanceAction) => {
      setSelectedTransaction(data);
      setShowModal(action);
    },
    [setSelectedTransaction, setShowModal]
  );

  const handleClickHistory = useCallback(
    (data: ITransactionDataModel) => {
      navigateToTransactionHistory(data);
    },
    [navigateToTransactionHistory]
  );

  return {
    handleClickAction,
    handleClickHistory,
    handleCloseModal,
  };
}

export function useInvestmentModalActions() {
  const setShowModal = useSetAtom(showModalStateFinance);
  const setSelectedInvestment = useSetAtom(selectedInvestmentStateFinance);

  const handleCloseModal = useCallback(() => {
    setShowModal(null);
    setSelectedInvestment(null);
  }, [setSelectedInvestment, setShowModal]);

  const handleClickAction = useCallback(
    (data: IFinanceRoundDataModel, action: TFinanceAction) => {
      setSelectedInvestment(data);
      setShowModal(action);
    },
    [setSelectedInvestment, setShowModal]
  );

  return {
    handleClickAction,
    handleCloseModal,
  };
}
